import { motion } from "framer-motion";
import { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import { Palette, ShoppingBag, Users, Shield, TrendingUp, Sparkles } from "lucide-react";

const FeaturesSection = () => {
  const { theme } = useContext(ThemeContext);

  const features = [
    {
      icon: <Palette className="w-8 h-8" />,
      title: "Créations Uniques",
      desc: "Des designs originaux créés par des artistes talentueux",
      items: ["Bannières premium", "Logos professionnels", "Illustrations sur mesure", "Templates réseaux sociaux"]
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Communauté Créative",
      desc: "Rejoignez une marketplace de créateurs passionnés",
      items: ["100+ créateurs actifs", "Échange avec les artistes", "Portfolio professionnel", "Support communautaire"]
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Transactions Sécurisées",
      desc: "Achetez et vendez en toute confiance",
      items: ["Paiements Stripe", "Protection anti-copie", "Fichiers sécurisés", "Garantie qualité"]
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Pour les Créateurs",
      desc: "Développez votre business créatif",
      items: ["Commissions équitables", "Gestion simplifiée", "Analytics détaillés", "Paiements rapides"]
    },
    {
      icon: <ShoppingBag className="w-8 h-8" />,
      title: "Pour les Acheteurs",
      desc: "Trouvez exactement ce dont vous avez besoin",
      items: ["Catalogue varié", "Téléchargement immédiat", "Formats multiples", "Support 24/7"]
    },
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: "Qualité Premium",
      desc: "Des créations vérifiées et approuvées",
      items: ["Contrôle qualité", "HD & Vector", "Fichiers sources", "Révisions incluses"]
    }
  ];

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className={`text-3xl sm:text-4xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Pourquoi Krayne Agency ?
          </h2>
          <p className={`text-lg ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
            La plateforme qui connecte créateurs et clients autour de la créativité digitale
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className={`p-6 rounded-xl transition-all hover:scale-105 ${
                theme === 'dark' 
                  ? 'bg-[#0b0b0c] border border-white/10 hover:border-rose-500/50' 
                  : 'bg-white border border-gray-200 hover:border-rose-500/50 shadow-sm hover:shadow-md'
              }`}
            >
              <div className={`inline-block p-3 rounded-lg mb-4 ${
                theme === 'dark' ? 'bg-rose-500/20 text-rose-400' : 'bg-rose-100 text-rose-600'
              }`}>
                {feature.icon}
              </div>
              <h3 className={`text-xl font-semibold mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                {feature.title}
              </h3>
              <p className={`mb-4 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                {feature.desc}
              </p>
              <ul className={`space-y-2 text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                {feature.items.map((item, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <span className="text-rose-500">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
